<template>
  <div class="animated fadeIn">
    <component-header
      :title="
        $route.params.id && partnerAllData
          ? `${partnerAllData.authentication.userName} - Partners`
          : 'Partners'
      "
      @search-query="val => (search = val)"
      @select-query="val => (this.selectedFilter = val)"
      :isLoading="loading"
      @reload-data="reloadData"
      @create-press="createPartner"
      :hasCreate="!$route.params.id"
      :hasback="false"
      :hasfilterOptions="filterOptions"
      @back-press="goToViewPage"
    />
    <b-card class="card-wrap" border-variant="info">
      <b-row v-if="$currentUserData.category != 'SELLER'">
        <b-col md="9"></b-col>
        <b-col md="3" class="float-right">
          <!-- <eb-select
            :options="filterOptions"
            :selected="selectedFilter.label"
            @input="onChangeFilter"
            id="value"
            type="text"
            label="label"
          ></eb-select> -->
        </b-col>
      </b-row>
      <div class="text-center" v-if="loading">
        <p>
          <b>Loading....</b>
        </p>
      </div>
      <div v-if="!loading">
        <!--card design start -->
        <b-row>
          <b-col
            class="pl-1 pr-1"
            md="4"
            v-for="(partner, i) in filteredList.slice(
              this.perPage * (this.currentPage - 1),
              this.currentPage * this.perPage
            )"
            :key="i"
          >
            <v-card
              class="item-card"
              role="button"
              @click="editTenant(partner)"
            >
              <v-card-text>
                <b-row>
                  <b-col
                    style="padding-right: 5px"
                    md="3"
                    class="pa-0 ma-0 pl-2 pr-0 mt-2"
                  >
                    <v-avatar size="60">
                      <img
                        :src="
                          partner.organization.logo &&
                          isUrlValid(partner.organization.logo.url)
                            ? partner.organization.logo.url
                            : 'img/avatars/6.jpg'
                        "
                      />
                    </v-avatar>
                  </b-col>
                  <b-col class="pl-0" md="9">
                    <v-card-title
                      class="pt-0 my-0 py-0 mb-1 font-weight-bold"
                      style="font-size: 17px, line-height:10px;"
                      >{{ partner.authentication.userName }}</v-card-title
                    >
                    <v-card-title class="py-0">
                      <span
                        class="pt-0 my-0 py-0 mb-1 font"
                        style="margin-top: -13px !important"
                      >
                        {{ partner.authentication.email }}
                        <!-- <img :src="partner.organization.logo.url" alt=""> -->
                      </span>
                      <span
                        class="pt-0 my-0 py-0 mb-1 font"
                        style="margin-top: -9px !important"
                      >
                        {{ partner.authentication.phone }}
                      </span>
                    </v-card-title>
                    <b-row>
                      <span class="my-0 py-0 font mr-2 ml-4 mt-1 mb-1"
                        >Category :
                      </span>
                      <span
                        style="font-size: 13px"
                        class="mt-1 my-0 py-0 mb-1"
                        >{{ getCategory(partner.category) }}</span
                      >
                    </b-row>
                    <b-row>
                      <span class="my-0 py-0 font mr-2 ml-4"
                        >Organization :</span
                      >
                      <span
                        style="font-size: 13px"
                        class="text-width my-0 py-0 mb-1"
                        >{{
                          partner.organization.name.slice(0, 22) + "..."
                        }}</span
                      >
                    </b-row>
                  </b-col>
                </b-row>
              </v-card-text>

              <!-- <b-button
                      @click="deletepartner(partner)"
                      class="my -0 main-navigation-button w-47"
                      variant="outline-danger"
                      >Delete</b-button
                    ></b-col
                  > -->
            </v-card>
          </b-col>
        </b-row>
        <b-row v-if="filteredList.length === 0" class="text-center">
          <b-col class="mt-5"><b>No data available!</b></b-col>
        </b-row>
        <!--card design end -->
      </div>
      <b-row justify="center" class="float-right">
        <b-col cols="8">
          <v-container class="max-width">
            <b-pagination
              v-if="filteredList.length > 0 && !loading"
              v-model="currentPage"
              :per-page="perPage"
              :total-rows="filteredList.length"
              aria-controls="my-table"
              prev-text="Prev"
              next-text="Next"
              hide-goto-end-buttons
            ></b-pagination>
          </v-container>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>
<script>
import ebButton from "@/components/FormElements/Button";
import ComponentHeader from "@/components/componentHeader";
import loader from "@/components/loader/nipigeloader.vue";
import ebSelect from "@/components/FormElements/Select.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "viewattribute",
  components: {
    ebButton,
    ebSelect,
    loader,
    ComponentHeader,
  },
  data() {
    return {
      partner: {},
      loading: false,
      currentPage: 1,
      search: "",
      selectedOption: "",
      perPage: 12,
      selectedFilter: "SELLER",
      partnerColumns: [
        {
          key: "userName",
          sortable: true,
        },
        {
          key: "email",
        },
        {
          key: "phone",
        },
        {
          key: "type",
        },
        {
          key: "action",
        },
      ],
    };
  },
  computed: {
    filterOptions() {
      if (this.$currentUserData.category === "DISTRIBUTOR") {
        return [
          { label: "SELLER", value: "SELLER" },
          { label: "SECTOR_FRANCHISEE", value: "DEALER" },
          { label: "TSK", value: "SUB_DEALER" },
        ];
      } else if (this.$currentUserData.category === "DEALER") {
        return [
          { label: "SELLER", value: "SELLER" },
          { label: "TSK", value: "SUB_DEALER" },
        ];
      } else if (this.$currentUserData.category === "SUB_DEALER") {
        return [{ label: "SELLER", value: "SELLER" }];
      } else {
        return [
          { label: "SELLER", value: "SELLER" },
          { label: "STATE_OPERATING_UNIT", value: "DISTRIBUTOR" },
          { label: "OFFICE", value: "OFFICE" },
          { label: "SECTOR_FRANCHISEE", value: "DEALER" },
          { label: "TSK", value: "SUB_DEALER" },
          {
            label: "SUPPLIER",
            value: "SUPPLIER",
          },
        ];
      }
    },
    ...mapGetters({ partnerAllData: "partner/GetPartnerData" }),
    filteredList() {
      let data = this.partners.filter(partner => {
        return (
          partner.authentication.userName
            .toLowerCase()
            .includes(this.search.toLowerCase()) &&
          partner.category === this.selectedFilter
        );
      });
      return data.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
    },
    partners() {
      let data = this.$store.getters["partner/GetPartnerList"];
      let partnerList = [];
      if (Array.isArray(data) && data.length > 0) {
        data.map(obj => {
          if (obj.category != "STOCK_POINT") {
            let arrayObj = {
              _id: obj._id,
              userName: obj.authentication.userName,
              email: obj.authentication.email,
              phone: obj.authentication.phone,
              type: obj.category,
              ...obj,
            };
            partnerList.push(arrayObj);
          }
        });
        return partnerList;
      } else {
        return [];
      }
    },
  },
  watch: {
    search(value) {
      this.currentPage = 1;
    },
  },
  methods: {
    ...mapActions({
      Getpartnerlist: "partner/fetchPartnersList", //
      Getchildpartnerlist: "partner/fetchChildPartnersList", //
    }),
    getCategory(data) {
      if (data) {
        if (data == "TENANT") {
          return "TENANT";
        } else if (data == "DISTRIBUTOR") {
          return "STATE_OPERATING_UNIT";
        } else if (data == "DEALER") {
          return "SECTOR_FRANCHISEE";
        } else if (data == "SUB_DEALER") {
          return "TSK";
        } else {
          return data;
        }
      } else {
        return "";
      }
    },
    reloadData() {
      this.$route.params.id
        ? this.getChildPartnerListData()
        : this.getPartnerListData(id);
    },
    // onChangeFilter(e) {
    //   this.selectedFilter = e;
    // },
    editTenant(data) {
      this.$store.dispatch("partner/editPartnerData", data);
      this.$router.push({
        name: "PartnerView",
        params: { id: data._id, parentId: data.officeHierarchy },
      });
    },
    goToViewPage() {
      if (this.$route.fullPath == "/partner") {
        this.$router.push({
          name: "Home",
        });
      } else {
        this.$router.push({
          name: "PartnerView",
          params: {
            id: this.$route.params.id,
            parentId: this.$route.params.parentId,
          },
        });
      }
    },
    createPartner() {
      this.$router.push("/partner/create");
    },

    getPartnerListData() {
      this.loading = true;
      this.Getpartnerlist().then(data => {
        if (data.message) {
          this.$toasted.error(data.message);
          this.loading = false;
        }
        this.loading = false;
      });
      this.$router.push("/partner");
    },
    getChildPartnerListData() {
      this.loading = true;
      let parentId = this.$route.params.id;
      this.Getchildpartnerlist(parentId).then(data => {
        if (data.message) {
          this.$toasted.error(data.message);
          this.loading = false;
        }
        this.loading = false;
      });
    },
    isUrlValid(userInput) {
      try {
        var res = userInput.match(
          /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
        );
        if (res == null) return false;
        else return true;
      } catch (err) {}
    },
  },
  async mounted() {
    this.loading = true;
    if (this.$route.params.id) {
      this.getChildPartnerListData();
    } else {
      this.getPartnerListData();
    }
  },
};
</script>

<style lang="sass" scoped>
.item-card
    width: 340px
    height: 175px
    max-height: 200px
    background: #FFFFFF
    border: 1px solid #ECECEC
    box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.1)
    border-radius: 10px
    padding: 2px


.font
   font-size: 15px
.edit
  color: white !important
.text-center
  text-align: center
.text-width
 width: 90px
.form-div label
  margin-top: 8px
</style>
